import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { logEvent } from "firebase/analytics";
  import { analytics } from './firebase';
import posthog from 'posthog-js';


  const REDIRECT_MAP = {
  r: {
    url: "https://hollowpad.web.app",
    event: "referral_reddit"
  },

  li: {
    url: "https://hollowpad.web.app",

    event: "referral_linkedin"
  },

  roforum: {                                               url: "https://hollowpad.web.app",
    event: "referral_roblox_forum"
  },

  medium: {                                               url: "https://hollowpad.web.app",
    event: "referral_medium"
  },

     hn: {        
      //Hacker news
     url: "https://hollowpad.web.app",
     event: "referral_hacker_news"
  },
	
  ig: {
    url: "https://hollowpad.web.app",
    event: "referral_instagram"
  }
  };

const LinkRedirector = () => {
  const { platform } = useParams();
  const target = REDIRECT_MAP[platform?.toLowerCase()];

  useEffect(() => {
    if (!target) {
      window.location.replace('/');
      return;
    }

    // TRACKING LOGIC
    try {
      // PostHog (Usually instant)
      posthog.capture(
	 "referral",
	     // target.event,
	      { 
        source: platform, 
	event: target.event
	
     //   destination: target.url 
      });

      // Firebase (Usually 24h delay in dashboard)
      logEvent(analytics, 
	       "referral",
	     // target.event,
	      { 
        platform_key: platform,
	event: target.event,
      });
    } catch (e) {
      console.error("Tracking failed", e);
    }

    // THE REDIRECT RACE: 
    // We wait 500ms to give the network requests a head start 
    // before the page unloads.
    const timer = setTimeout(() => {
      window.location.replace(target.url);
    }, 500);

    return () => clearTimeout(timer);
  }, [platform, target]);

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div className="spinner" style={styles.spinner}></div>
        <h2 style={styles.text}>Redirecting you...</h2>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#0f172a', // Slate 900
    fontFamily: 'system-ui, sans-serif'
  },
  card: {
    textAlign: 'center',
    color: 'white'
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid rgba(255,255,255,0.1)',
    borderTop: '4px solid #3b82f6',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 1rem'
  },
  text: {
    fontSize: '1.25rem',
    fontWeight: '500'
  }
};

// Add this to your index.css or a <style> tag
// @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

export default LinkRedirector;
